import config from 'react-global-configuration';

export const prependApiURLToImageStyles = (imageField) => {
  const API_URL = config.get('API_URL');

  imageField.get('styles', []).map((style, i) => {
    imageField = imageField.setIn(['styles', i], `${API_URL}/${style}`);
  });

  return imageField;
};
